var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ticket_way_container"
  }, [(_vm._i18n.locale === 'zh') ? _c('div', {
    staticClass: "container text-center color-ccc fs-30 empty-tip "
  }, [_vm._v(_vm._s(_vm.$t('public.ticketTips')))]) : _vm._e(), _vm._v(" "), (_vm._i18n.locale === 'en') ? _c('div', {
    staticClass: "container fs-30 flex_wrap bold"
  }, [_c('span', [_vm._v("A. Overseas Audience (E-ticket)")]), _vm._v(" "), _c('span', [_vm._v("Ticket Purchase Process for E-ticket (for users with WeChat) :")])]) : _vm._e(), _vm._v(" "), (_vm._i18n.locale === 'en') ? _c('span', {
    staticClass: "container fs-20 step_tips"
  }, [_vm._v("Step 1. Access the \"Guangzhou International Automobile Exhibition\" WeChat mini program.")]) : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/pubImg.png",
      "alt": ""
    }
  }), _vm._v(" "), (_vm._i18n.locale === 'en') ? _c('div', {
    staticClass: "container fs-20 flex_wrap"
  }, [_c('span', [_vm._v("Step 2. Select and purchase the ticket type as needed.")]), _vm._v(" "), _c('span', [_vm._v("Step 3. Follow the instructions to upload your passport information for real-name authentication.")]), _vm._v(" "), _c('span', [_vm._v("Step 4. After successful payment, scan your electronic QR code at the gate to enter the venue.")])]) : _vm._e(), _vm._v(" "), (_vm._i18n.locale === 'en') ? _c('div', {
    staticClass: "container fs-30  flex_wrap bold mt-30"
  }, [_c('span', [_vm._v("B. Overseas Audience (Physical Ticket)")]), _vm._v(" "), _c('span', [_vm._v("Ticket Purchase Process for Physical Ticket (for users without WeChat):")])]) : _vm._e(), _vm._v(" "), (_vm._i18n.locale === 'en') ? _c('span', {
    staticClass: "container fs-20 step_tips"
  }, [_vm._v("Step 1. Follow the on-site signs or seeking staffs for assistance to purchase tickets on-site.")]) : _vm._e(), _vm._v(" "), (_vm._i18n.locale === 'en') ? _c('img', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "src": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/sp.jpg",
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm._i18n.locale === 'en') ? _c('div', {
    staticClass: "container fs-20 flex_wrap"
  }, [_c('span', [_vm._v("Step 2. After purchasing the ticket, the staff will assist you in completing the real-name verification process by matching the ticket code with your personal identification information")]), _vm._v(" "), _c('span', [_vm._v("Step 3. Once the real-name authentication is completed, staff will assist you in scanning the code to enter the venue.")])]) : _vm._e()])
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60e9c9a6","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/schedule/components/ticketWay.vue
// module id = null
// module chunks = 